
import Vue from 'vue';
import pluralize from 'pluralize';
import { ROUTER } from '@/router/constants';
import { mapGetters, mapState } from 'vuex';
import { Company, Team } from '@run-diffusion/shared';
import { REPORTS } from '@/constants/constants';
import TeamPicker from '@/components/TeamPicker.vue';
import BackButton from '@/components/base/BackButton.vue';
import GlassButton from '@/components/base/GlassButton.vue';
import PageTopNavigation from '@/components/base/PageTopNavigation.vue';
import BaseToggleButton from '@/components/base/BaseToggleButton.vue';
import EmptyState from '@/components/states/EmptyState.vue';
import { TeamUserMixin } from '@/mixins';

export default Vue.extend({
	name: 'TeamReports',
	metaInfo () {
		if (this.hideRouterViewForReporting) {
			return {
				title: 'Reporting | RunDiffusion',
			};
		}
		return {
			titleTemplate: !this.selectedCompany
				? `%s | Reporting - ${this.selectedTeam?.name || this.displayLabels.team} | RunDiffusion`
				: `%s | Reporting - All ${pluralize(this.displayLabels.team)} | RunDiffusion`,
		};
	},
	data () {
		return {
			REPORTS,

			defaultTeamId: null,
			defaultCompanyId: null,
			defaultTeamMemberEmail: null,

			selectedTeam: null as Team,
			selectedCompany: null as Company,
			rdPlatformSelected: false,
		};
	},
	created () {
		this.defaultTeamId = (!this.$route.query.companyId && this.$route.query.teamId) || null;
		this.defaultCompanyId = this.$route.query.companyId || null;
		this.defaultTeamMemberEmail = this.$route.query.teamMemberEmail || null;

		// Initialize rdPlatformSelected
		this.rdPlatformSelected = this.$route.name === ROUTER.USER_USAGE_REPORT;
	},
	watch: {
		rdPlatformSelected: {
			immediate: false, // Initialized in created()
			handler (newVal: boolean, oldVal: boolean) {
				if (newVal !== oldVal) {
					if (!newVal && this.$route.name !== ROUTER.COMPANY_USAGE_REPORT) {
						this.routerReplace(this.$route, this.$router, {
							name: ROUTER.COMPANY_USAGE_REPORT,
							query: this.$route.query,
						});
					} else if (newVal && this.$route.name !== ROUTER.USER_USAGE_REPORT) {
						this.routerReplace(this.$route, this.$router, {
							name: ROUTER.USER_USAGE_REPORT,
							query: this.$route.query,
						});
					}
				}
			},
		},
	},
	mixins: [
		TeamUserMixin,
	],
	computed: {
		...mapState([
			'isAdminProxyingUser',
			'user',
			'team',
		]),
		...mapGetters([
			'displayLabels',
		]),
		hideRouterViewForReporting () {
			return !!(
				(!this.selectedCompany && !this.selectedTeam) ||
				!this.hasViewCompanyReportsPermission ||
				!(
					this.selectedCompany?.clubOffer?.benefits?.isEnterprise ||
					this.selectedTeam?.company?.clubOffer?.benefits?.isEnterprise ||
					this.user?.isAdmin ||
					this.isAdminProxyingUser
				)
			);
		},
		tabsData () {
			return [
				...(this.rdPlatformSelected ? [
					{
						text: 'User Usage',
						route: { name: ROUTER.USER_USAGE_REPORT },
					} as any,
					{
						text: 'App Metrics',
						route: { name: ROUTER.APP_METRICS_REPORT },
					} as any,
				] : []),
				...(!this.rdPlatformSelected ? [
					{
						text: 'Company Usage',
						route: { name: ROUTER.COMPANY_USAGE_REPORT },
					} as any,
				] : []),
			];
		},
	},
	methods: {
		onBack () {
			if (this.defaultTeamMemberEmail && this.selectedTeam) {
				this.routerPush(this.$route, this.$router, {
					name: ROUTER.TEAM_MEMBER_DASHBOARD,
					params: {
						teamId: this.selectedTeam.id,
						teamMemberId: this.defaultTeamMemberEmail,
					},
				});
			} else if (this.selectedTeam && !this.selectedCompany) {
				this.routerPush(this.$route, this.$router, {
					name: ROUTER.TEAM_DASHBOARD,
					params: {
						teamId: this.selectedTeam.id,
					},
				});
			} else {
				this.routerPush(this.$route, this.$router, {
					name: ROUTER.COMPANY_DASHBOARD,
				});
			}
		},
		onTeamPickerSelect ({ team, company, companyFirstTeam }) {
			this.selectedTeam = team || null;
			this.selectedCompany = company || null;
		},
	},
	components: {
		EmptyState,
		TeamPicker,
		BackButton,
		PageTopNavigation,
		BaseToggleButton,
		GlassButton,
	},
});
